import React from "react";
import MapLocationSelector from "../../../components/mapLocationSelector/MapLocationSelector";
import styles from "./newMythEditor.module.css";

export default function NewMythEditor({ currMyth, setCurrMyth }) {
  const onTitleChange = (e) =>
    setCurrMyth({ ...currMyth, title: e.target.value });

  const onExcerptChange = (e) => {
    let inputValue = e.target.value;
    if (inputValue.length > 150) {
      inputValue = inputValue.slice(0, 150);
    }

    setCurrMyth({ ...currMyth, excerpt: inputValue });
  };

  const onLocationChange = (newLocation) =>
    setCurrMyth({ ...currMyth, location: newLocation });

  return (
    <div className={styles.mythDataEditor}>
      <div className={styles.formField}>
        <h2>Tell us about the Myth:</h2>
        <label>
          <span className={styles.labelName}>Title: </span>
          <input
            type="text"
            name="title"
            value={currMyth.title}
            onChange={onTitleChange}
          />
        </label>
      </div>

      <div className={styles.formField}>
        <span className={styles.labelName}>Description: </span>

        <div className={styles.formField}>
          <textarea
            rows={5}
            value={currMyth.excerpt}
            onChange={onExcerptChange}
          />
        </div>
      </div>
      <div className={styles.formField}>
        <span className={styles.labelName}>Location: </span>
        <div className={styles.formSectionPreview}>
          <MapLocationSelector
            startCoords={currMyth.location}
            location={currMyth.location}
            setLocation={onLocationChange}
            autoOpen={false}
            zoom={17}
          />
        </div>
      </div>
    </div>
  );
}
